module.exports = __webpack_public_path__ + "img/Kachel_Letzte_Abfahrtskontrollen.281142ae.svg";